import PropTypes from 'prop-types';

export const propTypes = {
  returnToConfirmPrepay: PropTypes.func,
  commitState: PropTypes.object,
  airlineOptions: PropTypes.array,
};
